// extracted by mini-css-extract-plugin
module.exports = {"root":"root--4cetH","icon":"icon--dcV-2","email":"email--ESs+t"};